import { render, staticRenderFns } from "./ChatSideBarHistory.vue?vue&type=template&id=49785982&scoped=true&"
import script from "./ChatSideBarHistory.vue?vue&type=script&lang=js&"
export * from "./ChatSideBarHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatSideBarHistory.vue?vue&type=style&index=0&id=49785982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49785982",
  null
  
)

export default component.exports